$(function () {
    $('#hours_of_operation_monday_to_friday').daterangepicker({
        timePicker: true,
        timePickerIncrement: 1,
        timePickerSeconds: true,
        locale: {
            format: 'hh:mm A'
        }
    }).on('show.daterangepicker', function (ev, picker) {
        picker.container.find(".calendar-table").hide();
    });

    $('#hours_of_operation_satday').daterangepicker({
        timePicker: true,
        timePickerIncrement: 1,
        timePickerSeconds: true,
        locale: {
            format: 'hh:mm A'
        }
    }).on('show.daterangepicker', function (ev, picker) {
        picker.container.find(".calendar-table").hide();
    });
    $('#hours_of_operation_sunday').daterangepicker({
        timePicker: true,
        timePickerIncrement: 1,
        timePickerSeconds: true,
        locale: {
            format: 'hh:mm A'
        }
    }).on('show.daterangepicker', function (ev, picker) {
        picker.container.find('.calendar-table').hide();
    });
});